import  eventBus  from '../../common/MeshEditorJumper/eventBus.js';

const microAppsConfig = [
    {
        name: 'omnicraft-main',
        entry: window._env_.REACT_APP_SERVICE_OMNICRAFT_ENTRY,
        // entry: '//localhost:3001',
        container: '#ominicraft-root',
        activeRule: '/proxy/rodin/omnicraft',
        sandbox: false,
    },
    {
        name: 'mesheditor',
        entry: window._env_.REACT_APP_SERVICE_MESHEDITOR_ENTRY,
        container: '#mesheditor-root',
        activeRule: '/proxy/rodin/MeshEditor',
        sandbox: false,
        props:{
            eventBus:eventBus
        }
    },
    // {
    //     name: 'Omnicraft',
    //     entry: '//localhost:3003/',
    //     container: '#root',
    //     activeRule: ['/omnicraft'],
    // }
];

export { microAppsConfig };
